<template>
    <div class="apprentice-simple-card">
        <p>{{ $t('google_drive.cannot_link_file_to_account') }}</p>
    </div>
</template>

<script>
export default {
    name: 'design-2021-google-drive-error-component',
    props: ['emailIn'],
};
</script>

<style scoped></style>
